(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["elabell-purchase-options"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('elabell-purchase-options')){
 customElements.define('elabell-purchase-options',class extends HTMLElement{
  connectedCallback(){
   this.abort=new AbortController();const signal=this.abort.signal;
   this.form=this.closest('form');if(!this.form)return;
   this.prices=JSON.parse(this.querySelector('[data-eb-variants]').textContent);
   this.copy=JSON.parse(this.querySelector('[data-eb-copy]').textContent);
   this.querySelectorAll('[data-eb-extra-choice],[data-eb-extra-variant]').forEach(input=>input.disabled=false);
   this.addEventListener('click',event=>{
    const tier=event.target.closest('[data-eb-tier]');if(!tier)return;
    const target=Number(tier.dataset.ebTier),checked=[...this.querySelectorAll('[data-eb-extra-choice]:checked')];
    checked.slice(Math.max(0,target-1)).forEach(input=>input.checked=false);
    const extras=this.getSelectedItems().length;
    const quantity=this.form.querySelector('[name="quantity"]');
    if(quantity){
     const requested=Math.max(Number(quantity.min)||1,target-extras),step=Number(quantity.step)||1,min=Number(quantity.min)||1;
     const value=min+Math.ceil((requested-min)/step)*step;
     const selector=this.form.querySelector('quantity-selector-component');
     if(selector?.setValue)selector.setValue(value);else quantity.value=String(value);
     quantity.dispatchEvent(new Event('change',{bubbles:true}));
    }
    this.refresh();
   },{signal});
   this.form.addEventListener('change',()=>this.refresh(),{signal});
   this.form.addEventListener('input',()=>this.refresh(),{signal});
   this.form.addEventListener('click',()=>setTimeout(()=>{if(this.isConnected)this.refresh();},0),{signal});
   this.refresh();
  }
  getSelectedItems(){
   return [...this.querySelectorAll('.eb-unified-extra')].filter(card=>card.querySelector('[data-eb-extra-choice]').checked).map(card=>({variantId:card.querySelector('[data-eb-extra-variant]').value,quantity:1}));
  }
  refresh(){
   if(!this.form)return;
   const id=this.form.querySelector('[name="id"]')?.value,quantity=Number(this.form.querySelector('[name="quantity"]')?.value)||1;
   if(!id||this.prices[id]===undefined){this.querySelector('[data-eb-total]').textContent='—';this.querySelector('[data-eb-original]').hidden=true;this.querySelector('[data-eb-saving]').textContent='';this.querySelector('[data-eb-units]').textContent='';return;}
   let units=quantity,sum=Number(this.prices[id])*quantity;
   this.querySelectorAll('.eb-unified-extra').forEach(card=>{
    if(!card.querySelector('[data-eb-extra-choice]').checked)return;
    const select=card.querySelector('[data-eb-extra-variant]');units++;sum+=Number(select.selectedOptions[0].dataset.price);
   });
   const rate=units>=3?15:units>=2?10:0,saving=Math.floor(sum*rate/100);
   const money=value=>new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).format(value/100);
   this.querySelector('[data-eb-total]').textContent=money(sum-saving);
   const original=this.querySelector('[data-eb-original]');original.hidden=saving===0;original.textContent=money(sum);
   this.querySelector('[data-eb-saving]').textContent=saving?this.copy.saving+' '+money(saving)+' ('+rate+'%).':'';
   this.querySelector('[data-eb-units]').textContent=units+' '+this.copy.count;
   this.querySelectorAll('[data-eb-tier]').forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.ebTier)===(units>=3?3:units>=2?2:1))));
  }
  disconnectedCallback(){this.abort?.abort();}
 });
}
  } catch(e) { console.error(e); }
})();

})();
